"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
const _tagged_template_literal = require("@swc/helpers/_/_tagged_template_literal");
function _templateObject() {
    const data = _tagged_template_literal._([
        "\n  fragment Benefits on EditorialBenefits {\n    __typename\n    id\n    title\n    benefits {\n      __typename\n      caption\n      icon\n      content {\n        __typename\n        text\n        textLinks {\n          id\n          title\n          relativeUrl\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.benefitsFragment = void 0;
var _fetching = require("@ori/fetching");
const benefitsFragment = exports.benefitsFragment = (0, _fetching.gql)(_templateObject());
